export function imagePreviewer(file_id, preview_id) {
  $(file_id).on('change', (e) => {
    const file = e.target.files[0];
    if (!file) {
      // ファイルが選択されていない場合はプレビューをクリア
      $(preview_id).empty();
      return;
    }
    if (file.type.match('image/jpeg') || file.type.match('image/png')) {
      let d = new $.Deferred().resolve();
      d = d.then(() => previewImage(file));
    } else {
      // 画像ファイルでない場合はファイル・プレビュー削除
      e.currentTarget.value = '';
      $(preview_id).empty();
      alert('jpg/pngの画像ファイルのみ許可されています');
    }
  });

  const previewImage = (imageFile) => {
    const reader = new FileReader();
    const img = new Image();
    const def = $.Deferred();
    reader.onload = (e) => {
      // preview画像を表示
      $(preview_id).empty();
      $(preview_id).append(img);
      img.src = e.target.result;
      void def.resolve(img);
    };
    reader.readAsDataURL(imageFile);

    return def.promise();
  };
}
